/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import * as ContextMenuActionCreators from '@app/actions/ContextMenuActionCreators';
import {MenuGroup} from '@app/components/uikit/context_menu/MenuGroup';
import {CopyRoleIdMenuItem} from '@app/components/uikit/context_menu/items/CopyMenuItems';
import type React from 'react';

interface RoleContextMenuProps {
	roleId: string;
	onClose: () => void;
}

export const RoleContextMenu: React.FC<RoleContextMenuProps> = ({roleId, onClose}) => {
	return (
		<MenuGroup>
			<CopyRoleIdMenuItem roleId={roleId} onClose={onClose} />
		</MenuGroup>
	);
};

export function openRoleContextMenu(event: React.MouseEvent | MouseEvent, roleId: string): void {
	ContextMenuActionCreators.openFromEvent(event, ({onClose}) => <RoleContextMenu roleId={roleId} onClose={onClose} />);
}
